import { Injectable } from '@angular/core';
import { ClassType } from './class-type.model';

@Injectable()
export class ClassTypeUtilService {

    public orderClassTypesByName(classTypes: ClassType[] ): ClassType[] {
        if (!classTypes) {
            return classTypes;
        }

        return classTypes.sort( (a, b) =>  {
                                        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
                                        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
                                        if (nameA < nameB) {
                                            return -1;
                                        }
                                        if (nameA > nameB) {
                                            return 1;
                                        }

                                        // names must be equal
                                        return 0;
                                    });

    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/class-type/class-type.util.service.ts